export default __webpack_public_path__ + "static/media/rahimIqbal.01092b52.png";